import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReferralState, ReferralStats } from './types';

const initialState: ReferralState = {
  stats: null,
  loading: false,
  claiming: false,
  claimSuccess: null,
  claimError: null,
  joining: false,
  joinSuccess: null,
  joinError: null,
};

const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    setStats(state, action: PayloadAction<ReferralStats | null>) {
      state.stats = action.payload;
      state.loading = false;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setClaiming(state, action: PayloadAction<boolean>) {
      state.claiming = action.payload;
    },

    claimSuccess(state, action: PayloadAction<string>) {
      state.claiming = false;
      state.claimSuccess = action.payload;
      state.claimError = null;
    },

    claimFailure(state, action: PayloadAction<string>) {
      state.claiming = false;
      state.claimError = action.payload;
      state.claimSuccess = null;
    },

    resetClaimStatus(state) {
      state.claimSuccess = null;
      state.claimError = null;
    },

    setJoining(state, action: PayloadAction<boolean>) {
      state.joining = action.payload;
    },

    joinSuccess(state, action: PayloadAction<string>) {
      state.joining = false;
      state.joinSuccess = action.payload;
      state.joinError = null;
    },

    joinFailure(state, action: PayloadAction<string>) {
      state.joining = false;
      state.joinError = action.payload;
      state.joinSuccess = null;
    },

    resetJoinStatus(state) {
      state.joinSuccess = null;
      state.joinError = null;
    },

    // Saga triggers — no reducer logic
    fetchStatsRequest() {},
    claimRequest() {},
    joinRequest(_state, _action: PayloadAction<string>) {},
  },
});

export const referralActions = referralSlice.actions;
export const referralReducer = referralSlice.reducer;
